import Construction from "../components/Construction";

function Login() {
  return (<>
  <Construction />
  </>);
}

export default Login;
